import { addDays, subDays } from "date-fns";

export const defaultVehicle = {
  _id: "default",
  name: "HimRaahi",
  vehicleNum: "HP12A4567",
  src: "/rd.png",
  Type: "Bus",
  Trip: [],
  isVerified: false,
  totalDistance: 0,
  averageSpeed: 0,
  fuelEfficiency: 0,
};

export const defaultTrips = [
  {
    _id: "trip1",
    startLocation: "Shimla Bus Stand",
    endLocation: "Manali Bus Stand",
    date: subDays(new Date(), 1).toISOString(),
    startTime: "08:00 AM",
    endTime: "04:00 PM",
    distance: 250,
    status: "Completed",
    averageSpeed: 45,
    passengers: 32,
    driver: {
      name: "Sample Driver",
      phone: "+91 98765 43210",
    },
    stops: ["Shimla", "Bilaspur", "Mandi", "Kullu", "Manali"],
    stats: {
      fuelConsumed: 45,
      revenue: 12500,
      delays: 0,
    },
  },
  {
    _id: "trip2",
    startLocation: "Dharamshala",
    endLocation: "Chandigarh",
    date: subDays(new Date(), 2).toISOString(),
    startTime: "06:30 AM",
    endTime: "02:30 PM",
    distance: 235,
    status: "Completed",
    averageSpeed: 42,
    passengers: 28,
    driver: {
      name: "Sample Driver",
      phone: "+91 98765 43210",
    },
    stops: ["Dharamshala", "Una", "Ropar", "Chandigarh"],
    stats: {
      fuelConsumed: 42,
      revenue: 11200,
      delays: 1,
    },
  },
  {
    _id: "trip3",
    startLocation: "Manali",
    endLocation: "Leh",
    date: addDays(new Date(), 1).toISOString(),
    startTime: "05:00 AM",
    endTime: "Pending",
    distance: 420,
    status: "Scheduled",
    averageSpeed: 0,
    passengers: 25,
    driver: {
      name: "Sample Driver",
      phone: "+91 98765 43210",
    },
    stops: ["Manali", "Keylong", "Sarchu", "Leh"],
    stats: {
      fuelConsumed: 0,
      revenue: 18500,
      delays: 0,
    },
  },
];

export const defaultPerformanceData = [
  {
    id: "No Data",
    color: "hsl(217, 70%, 50%)",
    data: [
      { x: "Jan", y: 0 },
      { x: "Feb", y: 0 },
      { x: "Mar", y: 0 },
      { x: "Apr", y: 0 },
      { x: "May", y: 0 },
      { x: "Jun", y: 0 },
    ],
  },
];
